export const USER_ROLE = {
    CLIENT: "client",
    EXPERT: "expert",
    CONSEILLER: "conseiller",
};
